import React from "react"

import { IOneVerifyOrganizationUser } from "@common-shared/types/responseData/oneVerifyResponseData.types.ts"

import { AvatarElement } from "@front-shared/elements/avatar.element.tsx"
import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import chevronRightIcon from "@front-shared/assets/images/icons/chevron-right-dark3.svg"
import trashIcon from "@front-shared/assets/images/icons/trash-dark2.svg"

export const BillerGroupUsersListComponent: React.FunctionComponent<
    IBillerGroupUsersListComponentProps
> = props => {
    return (
        <div
            className={`
                relative
                ${props.className}
            `}
        >
            {props.users.map((user, index) => {
                const isSelected = user.id === props.selectedUser?.id
                const isLast = index === props.users.length - 1

                return (
                    <div
                        key={index}
                        className={`
                            flex items-center px-[24px] py-[12px]
                            ${
                                !isLast
                                    ? "border-b-[1px] border-solid border-brand-warmLight"
                                    : ""
                            }
                            ${
                                isSelected
                                    ? "bg-brand-lilacLight"
                                    : "bg-brand-white hover:bg-brand-whitePurple"
                            }
                            ${
                                props.onUserSelected && !isSelected
                                    ? "cursor-pointer"
                                    : ""
                            }
                        `}
                        onClick={() => props.onUserSelected?.(user)}
                    >
                        <AvatarElement
                            className="mr-[12px]"
                            user={user}
                            width={24}
                            fontClassName="text-[12px] leading-[12px] pt-[2px]"
                        />

                        <PrimaryText className="flex-1 mr-[16px]">
                            {user.name}
                        </PrimaryText>

                        <PrimaryText
                            typography="caption"
                            className={
                                props.onUserSelected || props.onUserRemoved
                                    ? "mr-[16px]"
                                    : ""
                            }
                        >
                            In {user.billerGroups.length} group
                            {user.billerGroups.length === 1 ? "" : "s"}
                        </PrimaryText>

                        {props.onUserSelected ? (
                            <div
                                className={
                                    props.onUserRemoved ? "mr-[16px]" : ""
                                }
                            >
                                <img src={chevronRightIcon} alt="Select" />
                            </div>
                        ) : null}

                        {props.onUserRemoved ? (
                            <div
                                onClick={e => {
                                    e.stopPropagation()
                                    props.onUserRemoved?.(user)
                                }}
                                className="cursor-pointer"
                            >
                                <img src={trashIcon} alt="Remove" />
                            </div>
                        ) : null}
                    </div>
                )
            })}
        </div>
    )
}

interface IBillerGroupUsersListComponentProps {
    className?: string
    users: IOneVerifyOrganizationUser[]
    selectedUser?: IOneVerifyOrganizationUser
    onUserSelected?: (user: IOneVerifyOrganizationUser) => void
    onUserRemoved?: (user: IOneVerifyOrganizationUser) => void
}
